import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { WebsiteAuditService } from '../website-audit.service';
import { UX_icons } from '../variables';

@Component({
  selector: 'app-technical',
  templateUrl: './technical.component.html',
  styleUrls: ['../ux/ux.component.css', './technical.component.css'],
})
export class TechnicalComponent implements OnInit, OnDestroy {
  constructor(private websiteAuditService: WebsiteAuditService) {}

  @ViewChild('separator') separator: any;

  private subs: Subscription = new Subscription();

  public scoreCards: any = [];
  public categories: any = {};

  public selectedScoreCard: any = {};

  private strokeWidth: number = 2;
  private style_width_height: number = window.innerWidth < 1441 ? 40 : 60;
  private style_font_size: string = window.innerWidth < 1441 ? '16px' : '22px';

  public progressCharts: any = [];

  private icons: any = UX_icons;

  public isLoading: boolean = false;

  ngOnInit(): void {
    this.subs.add(
      this.websiteAuditService.getSelectedAuditTask().subscribe((res: any) => {
        this.constructData(res);
      }),
    );

    this.subs.add(
      this.websiteAuditService.getAuditTasksLoading().subscribe((res: any) => {
        this.isLoading = res;
      }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  private constructData(res: any): void {
    function capitalizeFirstLetter(string: any) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    function sortByImpact(impact: any): any {
      const priority = (text: any): number => {
        if (text == 'high') return 0;
        if (text == 'medium') return 1;
        return 2;
      };

      return [...impact].sort((a, b) => {
        const priorityDiff = priority(a['impact']) - priority(b['impact']);
        if (priorityDiff !== 0) return priorityDiff;

        return a['impact'].localeCompare(b['impact']);
      });
    }

    // score cards
    try {
      this.categories =
        res?.auditRankings?.technicalCategories?.categories || {};

      this.scoreCards = [];

      Object.keys(this.categories).forEach((key) => {
        let workingWell = this.categories[key]?.data
          ?.filter((issue: any) => ['info', 'pass'].includes(issue.status))
          .map((issue: any) => {
            issue['workingWell'] = true;
            issue['text'] = issue['title'];
            return issue;
          });
        let notWorkingWell = this.categories[key]?.data
          ?.filter((issue: any) => !['info', 'pass'].includes(issue.status))
          .map((issue: any) => {
            issue['notWorkingWell'] = true;
            issue['text'] = issue['title'];
            return issue;
          });

        workingWell = sortByImpact(workingWell);
        notWorkingWell = sortByImpact(notWorkingWell);

        const optimalScore =
          this.categories[key]?.averages?.score <
          this.categories[key]?.averages?.optimalScore
            ? Math.round(this.categories[key]?.averages?.optimalScore || 100)
            : Math.max(
                Math.round(this.categories[key]?.averages?.optimalScore || 100),
                100,
              );

        this.scoreCards.push({
          title: capitalizeFirstLetter(key),
          value: Math.round(this.categories[key]?.averages?.score || 0),
          workingWell,
          notWorkingWell,
          icon: this.icons?.[key] || false,
          averageScore: Math.round(this.categories[key]?.averages?.score || 0),
          optimalScore: optimalScore,
        });
      });

      this.selectScoreCard(this.scoreCards?.[0]);
    } catch (e) {
      console.log(e);
    }

    // progress charts
    try {
      const progressCharts = res?.auditRankings?.metricsRanking || [];

      // value: 0,
      //   title: 'Performance',
      //   style: {
      //     strokeWidth: this.strokeWidth,
      //     width: this.style_width_height,
      //     height: this.style_width_height,
      //     valueFontSize: this.style_font_size,
      //     titleBottom: true,
      //     secondStyle: true,
      //   },

      this.progressCharts = [];
      progressCharts.forEach((element: any) => {
        this.progressCharts.push({
          title: element.name,
          description: element.description,
          reason: element.reason,
          chart: {
            value: element.score || 0,
            style: {
              strokeWidth: this.strokeWidth,
              width: this.style_width_height,
              height: this.style_width_height,
              valueFontSize: this.style_font_size,
              titleBottom: true,
              // secondStyle: true,
            },
          },
        });
      });
    } catch (e) {
      console.log(e);
    }
  }

  public selectScoreCard(card: any): void {
    if (!card) {
      return;
    }

    this.scoreCards.forEach((scoreCard: any) => {
      scoreCard.selected = false;
    });
    card.selected = true;
    // this.selectedScoreCard = card;
    this.selectedScoreCard.title = card.title;
    this.selectedScoreCard.value = card.value;

    this.selectedScoreCard.notWorkingWell = card?.notWorkingWell;
    this.selectedScoreCard.workingWell = card?.workingWell;

    requestAnimationFrame(() => {
      if (this.separator?.nativeElement) {
        this.separator.nativeElement.style.height = '0px';
        setTimeout(() => {
          this.separator.nativeElement.style.height =
            this.separator.nativeElement.parentElement?.scrollHeight + 'px';
        }, 100);
      }
    });
  }
}
